import { CustomToolbar } from 'admin/toolbars/CustomToolbar';
import { Edit, SelectInput, SimpleForm, TextInput } from 'react-admin';

import { CLIENT_STATUSES } from './clientUtils';

export const ClientEdit: React.FC = () => {
  return (
    <Edit mutationMode="pessimistic" redirect="show">
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput disabled={true} label="Meno" source="user.name" sx={{ width: '40em' }} />
        <TextInput disabled={true} label="Priezvisko" source="user.surname" sx={{ width: '40em' }} />
        <TextInput disabled={true} label="E-mail" required source="user.email" sx={{ width: '40em' }} />
        <TextInput disabled={true} label="Tel." source="user.phoneNumber" sx={{ width: '40em' }} />
        <SelectInput choices={CLIENT_STATUSES} label="Stav" source="status" />
      </SimpleForm>
    </Edit>
  );
};
